"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Login;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var Yup = _interopRequireWildcard(require("yup"));
var _ = require("..");
var Icons = _interopRequireWildcard(require("../Icons"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var LoginSchema = Yup.object().shape({
  username: Yup.string().min(4, 'Muy corto!').max(20, 'Muy Largo!').required('Requerido'),
  password: Yup.string().required('Requerido')
});
var initialValues = {
  username: '',
  password: '' // NOSONAR
};
var errorMessage = 'Tu usuario y/o contraseña son inválidos.';
function Login(_ref) {
  var login = _ref.login,
    loading = _ref.loading,
    error = _ref.error,
    resetLogin = _ref.resetLogin;
  var formikRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    submitted = _useState2[0],
    setSubmitted = _useState2[1];
  (0, _react.useEffect)(function () {
    if (formikRef.current && error) {
      formikRef.current.setErrors(initialValues);
    }
  }, [formikRef, error]);
  var handleFormik = (0, _react.useCallback)(function (values) {
    login(values);
  }, [login]);
  var resetForm = (0, _react.useCallback)(function () {
    setSubmitted(false);
    resetLogin();
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "page-login"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container"
  }, loading && !error ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-md-1"
  }, /*#__PURE__*/_react["default"].createElement(Icons.Logo, {
    className: "page-login-scaling",
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-md-6 text-center"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-white",
    style: {
      fontSize: '20px'
    }
  }, "Cargando...")))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-11 col-sm-10 col-md-6 col-lg-5"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "page-login-form"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row justify-content-center page-login-form-top"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col d-flex justify-content-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: ""
  }, /*#__PURE__*/_react["default"].createElement(Icons.Logo, {
    width: "100px"
  })))), /*#__PURE__*/_react["default"].createElement("h1", {
    className: "text-center sub text-uppercase"
  }, "Iniciar Sesi\xF3n"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-center"
  }, "Antes de continuar, por favor ingresa tu usuario y contrase\xF1as"), /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: initialValues,
    validationSchema: LoginSchema,
    validateOnChange: submitted,
    validateOnBlur: true,
    onSubmit: handleFormik,
    innerRef: formikRef
  }, function (_ref2) {
    var isValid = _ref2.isValid,
      handleSubmit = _ref2.handleSubmit;
    return /*#__PURE__*/_react["default"].createElement("form", {
      onSubmit: function onSubmit(evt) {
        evt.preventDefault();
        setSubmitted(true);
        resetLogin();
        handleSubmit();
      }
    }, /*#__PURE__*/_react["default"].createElement(_.PlainInput, {
      name: "username",
      label: "Usuario",
      type: "text",
      onlyError: true,
      displayError: false
    }), /*#__PURE__*/_react["default"].createElement(_.PasswordInput, {
      onBlur: resetForm,
      name: "password",
      label: "Contrase\xF1a",
      onlyError: true,
      displayError: false
    }), (error || !isValid && submitted) && /*#__PURE__*/_react["default"].createElement("span", {
      className: "col-form-error text-danger"
    }, error || errorMessage), /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-bold text-center mt-4 mb-4"
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: "small",
      href: "#"
    }, "Olvid\xE9 mi contrase\xF1a")), /*#__PURE__*/_react["default"].createElement(_.Button, {
      block: true
    }, "Aceptar"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-center w-100 mt-3"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      "class": "col-form-info-text mt-1 d-block"
    }, "\xA9 2024 Casanova (v1.7.0)")));
  })))))));
}